import { gql } from "@apollo/client";

export const CURRENT_USER = gql`
  query {
    me {
      _id
      firstName
      lastName
      email
      profileUrl
      creditBalance
      firstSubscriptionAt
      invalidGrant
      rateLimitExceeded
      partialAccount
      hasGmail
      hasCalendar
      hasZoom
      services
      stripeCustomerId
      vipUser
      settings {
        timeZone
        language
        createNoteShortcut
        createTaskShortcut
        language
        timeZone
      }
      tempLocation
      preferences {
        location
        secondaryLocation
        language
        timezone
        firstName
        lastName
      }
      notifications {
        hasNotification
        morningSummary
        notSendIfNoEvents
        endOfDayNotification
        endOfWeekNotification
        sundayNotification
        timeToReceivePrep
      }
    }
  }
`;

export const USER_SETTINGS = gql`
  query {
    me {
      _id
      meetingBotSettings {
        joinMeetings
        followUpEmail
        meetingNoteEmail
      }
      settings {
        timeZone
        language
        createNoteShortcut
        createTaskShortcut
        language
        timeZone
      }
      preferences {
        location
        secondaryLocation
        language
        timezone
        firstName
        lastName
        emailSignature
      }
      notifications {
        hasNotification
        morningSummary
        notSendIfNoEvents
        endOfDayNotification
        endOfWeekNotification
        sundayNotification
        timeToReceivePrep
      }
    }
  }
`;

export const ACTIVATED_INTEGRATIONS = gql`
  query UserIntegrations {
    userIntegrations {
      id
      type
    }
  }
`;

export const CURRENT_SUBSCRIPTION = gql`
  query {
    currentSubscription {
      plan
      startAt
      endAt
      autoRenew
      isTrial
      billingCycle
      canceledAt
    }
  }
`;

export const PODCAST = gql`
  query Podcast($dayOffset: Int) {
    podcasts(dayOffset: $dayOffset) {
      type
      url
      chapter
      title
      created
      transcript
      audioDuration
    }
  }
`;

export const GET_TRANSCRIPTS = gql`
  query Transcripts($meetingId: String, $date: Float) {
    transcripts(meetingId: $meetingId, date: $date) {
      _id
      summary
      detailedSummary
      meetingId
      meetingTitle
      meetingDate
      created
      transcript
    }
  }
`;
export const GET_TRANSCRIPT = gql`
  query Transcripts($id: ID!) {
    transcript(id: $id) {
      _id
      summary
      detailedSummary
      meetingId
      meetingTitle
      meetingDate
      created
      transcript
    }
  }
`;

export const GET_TODOS = gql`
  query Todos {
    todos {
      _id
      title
      source
      sourceId
      created
      dueDate
      priority
      url
    }
  }
`;

export const GET_LABEL_SETTINGS = gql`
  query InboxLabelSettings {
    inboxLabelSettings {
      name
      defaultBehavior
    }
  }
`;

export const GET_ARCHIVE_SETTING = gql`
  query EmailArchiveLevel {
    emailArchiveLevel
  }
`;

export const GET_CALENDAR_LINK = gql`
  query CalendarLink {
    calendarLink
  }
`;
